import { httpClient } from "../../../shared/api";
import { API } from "../../../cache";

function cleanQuery(params = {}) {
  const out = {};
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    out[k] = v;
  });
  return out;
}

export const featuresApi = {
  // ── Features ────────────────────────────────────────────────────────────────
  listFeatures: (params = {}) =>
    httpClient.get("/features", { query: cleanQuery(params) }),

  listFeaturesWithSubs: () => httpClient.get("/features/all-with-subs"),

  getFeature: (id) => httpClient.get(`/features/${id}`),

  createFeature: (body) => httpClient.post("/features", body),

  updateFeature: (id, body) => httpClient.put(`/features/${id}`, body),

  deleteFeature: (id) => httpClient.delete(`/features/${id}`),

  // ── Sub-features ────────────────────────────────────────────────────────────
  listSubFeatures: (params = {}) =>
    httpClient.get("/sub-features", { query: cleanQuery(params) }),

  getSubFeature: (id) => httpClient.get(`/sub-features/${id}`),

  createSubFeature: (body) => httpClient.post("/sub-features", body),

  updateSubFeature: (id, body) => httpClient.put(`/sub-features/${id}`, body),

  deleteSubFeature: (id) => httpClient.delete(`/sub-features/${id}`),

  // ── Sub-feature team mapping ────────────────────────────────────────────────
  getSubFeatureTeamMapping: (subFeatureId) =>
    httpClient.get(`/sub-features/${subFeatureId}/team-mapping`),

  putSubFeatureTeamMapping: (subFeatureId, mappings) =>
    httpClient.put(`/sub-features/${subFeatureId}/team-mapping`, mappings),

  // ── Excel template + upload ─────────────────────────────────────────────────
  excelTemplateUrl: () => `${API}/features/excel-template`,

  uploadExcel: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${API}/features/upload-excel`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data?.detail || `Upload failed (${res.status})`);
      err.status = res.status;
      throw err;
    }
    return data;
  },

  // ── Meta ────────────────────────────────────────────────────────────────────
  listProducts: () => httpClient.get("/products"),

  listTeams: () => httpClient.get("/teams"),
};
